import React, { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";
import axios from 'axios';
import compLogo from './CA-Markets-Global-Logo-Colour-02.png'
//var res = await axios.get(`https://y4328g9e4g.execute-api.ap-east-1.amazonaws.com/prod/boc`)
export default function Home() {
    const navigate = useNavigate();
    const [data, setData] = useState([])

    async function fetchdata() {

        return await axios.get(`https://y4328g9e4g.execute-api.ap-east-1.amazonaws.com/prod/boc`, {
            headers: {
                'x-api-key': '59a7ad19f5a9fa0808f11931',
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
            }
        }).then(function (res) { setData(res.data.message) })

    }
    useEffect(() => {
        fetchdata();
        console.log(data)


    }, [])
    //<div><img src={compLogo} alt="CA Markets Global. Logo" width="230" height="48"/></div>
    return (
        <div>


            <div class="fdiv">
                <table class="styled-table" style={{ width: "80%" }} >
                    <thead>
                        <tr>
                            <th>Bank/银企名称</th>
                            <th>Currency/货币</th>
                            <th>Dep Rate/入金汇率</th>
                            <th>Wdr Rate/出金汇率</th>
                            <th>Last Update/发布时间</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((dataval) => (
                        <tr>
                            <td>{dataval.name}</td>
                            <td>{dataval.currency}</td>
                            <td>{dataval.sell}</td>
                            <td>{dataval.buy}</td>
                            <td>{dataval.dt}</td>
                        </tr>
                
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}